<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
 

      <div class="page-wrapper">

          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">{{ $t("salesSurvey") }} V2 </h4>
                    <div class="float-start">
                        <div
                        class="input-group wd-250 me-2 mb-2 mb-md-0"
                        id="dashboardDate"
                        >
                            <vuejsDatepicker
                            v-model="filterDate"
                            :format="DatePickerFormat"
                            minimum-view="year"              
                            name="datepicker"
                            id="input-id"
                            input-class="form-control"
                            @selected="checkSelected"
                            ></vuejsDatepicker>
                        </div>
                    </div>
                    <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="createData()">
                      <i class="link-icon mdi mdi-plus"></i>
                      {{ $t("createNew") }}
                    </button>
   
                    <button v-if="permision_role.method_read" class="btn btn-dark float-end btn-xs"
                      style="margin-right: 5px" @click="massUpload()" type="button">
                      <i class="link-icon mdi mdi-upload"></i>
                      Upload
                    </button>

                    <div class="btn-group float-end" style="margin-right: 5px;">
                        <button type="button" class="btn btn-sm btn-success" @click.prevent="downloadData()">
                            <i class="link-icon mdi mdi-download"></i>
                            {{ $t("downloadData") }} .xlsx
                        </button>
                        <button type="button" class="btn btn-success  btn-sm dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" href="#" @click.prevent="downloadCustom('summary')">{{ $t('salesSurveySummary') }}</a>
                            <a class="dropdown-item" href="#" @click.prevent="downloadCustom('priority')">{{ $t('salesSurveyPriority') }}</a>
                        </div>
                    </div>


                  
  
                  </div>
  
                  <div class="card-body">
                    <vue-good-table title="list-sales-survey-ceisa-client-login" ref="list-sales-survey-ceisa-client-login"
                      mode="remote" @on-page-change="onPageChange"
                      @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" 
                    :select-options="{
                        enabled: true,
                        selectAllByGroup: true,
                        selectOnCheckboxOnly: true,
                        selectionText: $t('data_selected'),
                        clearSelectionText: $t('clear'),
                    }" 
                    @on-selected-rows-change="selectionChanged"
                    @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                    :isLoading.sync="isLoading" :pagination-options="{
                    
                    enabled: true,
                    perPageDropdown: [10, 50, 100, 1000, 10000],
                    dropdownAllowAll: false,
                    }" :rows="rows" :columns="columns">
                      <div slot="selected-row-actions">
                        <button class="btn btn-success btn-xs" :disabled="reSendEmail" style="margin-right: 20px" @click="sendEmail">
                        <i class="mdi mdi-email-fast"></i>
                        Re-Send Email
                        </button>
                      </div>
                      <template slot="table-row" slot-scope="props">
                        
                            <span v-if="props.column.field == 'actions'">
                            <a href="#" v-if="permision_role.method_read" title="Copy" @click.prevent="
                                copyLink(props.index, props.row)
                                ">
                                <i class="mdi mdi-content-copy" style="font-size:16px;color:green;"></i>
    
                            </a>
                            <a href="#" v-if="permision_role.method_read" v-show="props.row.status == 'NEW' " class="me-1" title="Re-Send Email" @click.prevent="
                                reSendMail(props.index, props.row)
                                ">
                                <i class="mdi mdi-email-fast" style="font-size:16px;color:green;"></i>
    
                            </a>
                            <a href="#" v-if="permision_role.method_read" title="Detail" @click.prevent="
                                detailData(props.index, props.row)
                                ">
                                <i class="mdi mdi-eye" style="font-size:16px;color:blue;"></i>
    
                            </a>
                            <a href="#" v-if="permision_role.method_update" title="Edit"  v-show="props.row.status == 'NEW' "
                                @click.prevent="editData(props.index, props.row)">
                                <i class="mdi mdi-square-edit-outline" style="font-size:16px;color:#66d1d1;"></i>
    
                            </a>
                            <a
                                href="#"
                                v-if="permision_role.method_delete"
                                v-show="props.row.status == 'NEW' "
                                title="Delete"
                                @click.prevent="
                                    deleteData(props.index, props.row)
                                "
                            >
                                <i class="mdi mdi-trash-can-outline" style="font-size:16px;color:red"></i> 
                            </a>
                        
     
                            
                            </span>

    
                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                            
                      </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
   

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import Hashids from 'hashids';
import vuejsDatepicker from "vuejs-datepicker";
 

export default {
    name: "SalesSurveyIndex2025",
    props: {},
    components: {

        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        vuejsDatepicker,

    },
    data() {
        const startDate = new Date();// new Date();
        const endDate = new Date();

        return {
            type:"bp",
            dateFilter: {
                startDate,
                endDate,
            },
            asnType: [],
            fetchAsnType: [],
            trackingOrderStatus: [],

            filterDate:startDate,
            DatePickerFormat: 'yyyy',
            yearFilter: startDate.getFullYear(),

            expectedShipmentTime1dateFilter: {
                startDate,
                endDate,
            },

            showModalNow: false,

            opens: "center",
            locale: {
                format: "yyyy-mm-dd H:MM:ss",
            },

            localeDetail: {
                format: "yyyy-mm-dd",
            },

            highlighted: {

                dates: [ // Highlight an array of dates
                new Date(),
                ],

            },
            digit: {
                decimal: ',',
                thousands: '.',
                prefix: ' ',
                suffix: '',
                precision: 5,
                masked: false
            },
            fetchStockCondition: [],
            detailAsn: [],
            orderType: '',
            fetchOrderType: [],
            shelfLifeUnit: {},
            shelfLifeType: {},
            permision_role: [],
            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            userRole: "",
            companyCode: "",
            fetchStatus: ['ACTIVE', 'DEACTIVE'],
            fetchmultiWhFlag: ['Y', 'N'],
            fetchCustomer: [],
            fetchFulfillment: [],
            customer: "",
            fulfillment: "",
            fetchShelfLifeType: [],
            fetchShelfLifeUnit: [],
            fetchSku: [],
            activeFlag: false,
            shelfLifeFlag: false,
            kitFlag: false,
            freePickGift: false,
            isLoadingStatus: false,
            forms: {client_id:"", username:"", password:"", endpoint:"",  created_by:"", updated_by:"" , created_at:"", updated_at:""},
            serverParams: {
            columnFilters: {},
            sort: {
                field: "",
                type: "",
            },
            page: 1,
            per_page: 10,
            },
       
            columns: [
    
                {
                    label: this.$t("linc_company"),
                    field: "linc_company",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: this.$t("linc_sales_email"),
                    field: "linc_sales_email",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Customer Company Name",
                    field: "customer_company",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "PIC Name",
                    field: "customer_name",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                }, 
                {
                    label: this.$t("customer_email"),
                    field: "customer_email",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("customer_departement"),
                    field: "customer_departement",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                }, 
                {
                    label: this.$t("survey_years"),
                    field: "years",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: this.$t("status"),
                    field: "status",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                }, 
                {
                    label: "Total Reminder",
                    field: "reminderSeq",
                    thClass: 'text-center'
                }, 
                {
                    label: "Last Send Email",
                    field: "last_send_email",
                    thClass: 'text-center'
                }, 
     
                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                    }
                },
            ],
            rows: [],
            rowsSelection: [],
            selectedIds:[],
            reSendEmail:false,
            totalRecords: 0,
        };
    },
    watch: {},
    methods: {

        selectionChanged(ev){
            this.rowsSelection = [];
            this.selectedIds = [];
            this.reSendEmail = false;
            this.rowsSelection = ev.selectedRows;
            this.rowsSelection.forEach((item)=>{
                if(item.status == "DONE"){
                    this.reSendEmail = true;
                }

                this.selectedIds.push(item.id_header);

            });
        },

        sendEmail(){
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t('submitFormTxt'),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                        
                    this.isLoading = true;
                    let data = {
                        ids : this.selectedIds
                    };
                    const baseURI = this.$settings.endPointCeisa + "v1/sales-survey-2025/mass-resend-email";
                    this.$http.post(baseURI, data, { timeout: 10000 }).then((response) => {
                        
                        this.isLoading = false;

                        if (response.data.status === 200) {
                            this.success("Berhasil");
                        } else {
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }

                        this.loadItems();

                    }).catch((error) => {

                        this.isLoading = false;

                        if (error.code == "ECONNABORTED") {
                            this.error(this.$t("check_internet_connection_txt"));

                        } else {


                            if (error.code == "ECONNABORTED") {
                                
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {

                                if (error.response) {
                                    if (error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 401) {
                                    this.logout();
                                    } else if (error.response.status === 403) {
                                    this.$router.push("/authorized-error");
                                    } else if (error.response.status === 500) {
                                    this.$router.push('/server-error');
                                    } else {
                                    this.$router.push('/page-not-found');
                                    }
                                }

                            }

                        }

                    });

                } else {

                    this.isLoading = false;
                }
            });
        },

        deleteData(index, row, status) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataDelete"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                var formData = {
                    status: status,
                };
                const baseURI =
                    this.$settings.endPointCeisa + "v1/sales-survey-2025/delete/" + row.id_header;
                this.$http
                    .delete(baseURI, formData)
                    .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                        this.success(response.data.datas.messages);
                        this.loadItems();
                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                    })
                    .catch((error) => {
                    this.loading();
                    if (error.response) {
                        if(error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                        }else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        }else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        }else{
                            this.$router.push('/page-not-found');
                        }
                    }
                    });
                }else{
                this.isLoading = false;
                }
            });
        },

        checkSelected(ev){
            let dates = new Date(ev);
            this.yearFilter = dates.getFullYear();
            this.loadItems();
        },

        reSendMail(index,row){
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t('submitFormTxt'),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                        
                    this.isLoading = true;
                    
                    const baseURI = this.$settings.endPointCeisa + "v1/sales-survey-2025/resend-email/"+row.id_header;
                    this.$http.post(baseURI, this.forms, { timeout: 10000 }).then((response) => {
                        
                        this.isLoading = false;

                        if (response.data.status === 200) {
                            this.success("Berhasil");
                        } else {
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }

                        this.loadItems();

                    }).catch((error) => {

                        this.isLoading = false;

                        if (error.code == "ECONNABORTED") {
                            this.error(this.$t("check_internet_connection_txt"));

                        } else {


                            if (error.code == "ECONNABORTED") {
                                
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {

                                if (error.response) {
                                    if (error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 401) {
                                    this.logout();
                                    } else if (error.response.status === 403) {
                                    this.$router.push("/authorized-error");
                                    } else if (error.response.status === 500) {
                                    this.$router.push('/server-error');
                                    } else {
                                    this.$router.push('/page-not-found');
                                    }
                                }

                            }

                        }

                    });

                } else {

                    this.isLoading = false;
                }
            });
        },

        hashId(id){
            var hashids = new Hashids('',100,'abcdefghijklmnopqrstuvwxyz0987654321ABCDEFGHIJKLMNOPQRSTUVWXYZ'); // no padding
            return hashids.encode(id); 
        },

        copyLink(index,row){
            const url = this.$settings.endpointSurvey;
            const clipboardData =
                event.clipboardData ||
                window.clipboardData ||
                event.originalEvent?.clipboardData ||
                navigator.clipboard;
            var message = url+"survey/"+this.hashId(row.id_header);
            clipboardData.writeText(message);
            this.success("Copy Success");
        },

        createData() {
            window.location.href = "/sales-survey/v2/create";
        },
 
        detailData(index, row) {
    
            var params = this.$onRandom(row.id_header);
            window.location.href = "/sales-survey/v2/detail/" + params;

        },

        downloadData() {
            const baseURI = this.$settings.endPointCeisa + "v1/sales-survey-2025/index";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";    
            this.isLoading = true;


            return this.$http.get(
                baseURI +
                `?sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&linc_company=${this.serverParams.columnFilters.linc_company}&linc_sales_email=${this.serverParams.columnFilters.linc_sales_email}&customer_name=${this.serverParams.columnFilters.customer_name}&customer_email=${this.serverParams.columnFilters.customer_email}&customer_departement=${this.serverParams.columnFilters.customer_departement}&years=${this.yearFilter}&customer_company=${this.serverParams.columnFilters.customer_company}&status=${this.serverParams.columnFilters.status}&download=download`,
    
                {
                responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.isLoading = false;
                
            }).catch((error) => {

                this.isLoading = false;
  
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
  
                } else {
  
  
                  if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
  
                  } else {
  
                    if (error.response) {
                      if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                      } else if (error.response.status === 401) {
                        this.logout();
                      } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                      } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                      } else {
                        this.$router.push('/page-not-found');
                      }
                    }
  
                  }
  
                }
            });

        },

        downloadCustom(type){
            const baseURI = this.$settings.endPointCeisa + "v1/sales-survey-2025/index";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";    
            this.isLoading = true;


            return this.$http.get(
                baseURI +
                `?sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&linc_company=${this.serverParams.columnFilters.linc_company}&linc_sales_email=${this.serverParams.columnFilters.linc_sales_email}&customer_name=${this.serverParams.columnFilters.customer_name}&customer_email=${this.serverParams.columnFilters.customer_email}&customer_departement=${this.serverParams.columnFilters.customer_departement}&years=${this.yearFilter}&customer_company=${this.serverParams.columnFilters.customer_company}&status=${this.serverParams.columnFilters.status}&download=${type}`,
    
                {
                responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.isLoading = false;
                
            }).catch((error) => {

                this.isLoading = false;
  
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
  
                } else {
  
  
                  if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
  
                  } else {
  
                    if (error.response) {
                      if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                      } else if (error.response.status === 401) {
                        this.logout();
                      } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                      } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                      } else {
                        this.$router.push('/page-not-found');
                      }
                    }
  
                  }
  
                }
            });
        },

        massUpload() {
            window.location.href = "/sales-survey/v2/upload";
        },
  

        loadItems() {

            const baseURI = this.$settings.endPointCeisa + "v1/sales-survey-2025/index";

            this.isLoading = true;
            

            return this.$http.get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&linc_company=${this.serverParams.columnFilters.linc_company}&linc_sales_email=${this.serverParams.columnFilters.linc_sales_email}&customer_name=${this.serverParams.columnFilters.customer_name}&customer_email=${this.serverParams.columnFilters.customer_email}&customer_departement=${this.serverParams.columnFilters.customer_departement}&years=${this.yearFilter}&customer_company=${this.serverParams.columnFilters.customer_company}&status=${this.serverParams.columnFilters.status}`,
                { timeout: 10000 })
                .then((response) => {

                    this.isLoading      = false;
                    this.rows           = response.data.datas.data;
                    this.totalRecords   = response.data.datas.total;

                 }).catch((error) => {
                    
                    this.isLoading      = false;
    
                if (error.code == "ECONNABORTED") {
                    
                    this.error(this.$t("check_internet_connection_txt"));
    
                }else{
    
                    if (error.response) {
                        if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                        this.logout();
                        } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                        } else {
                        this.$router.push('/page-not-found');
                        }
                    }
    
                }
            });
        },

  
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },
  
        onColumnFilter(params) {
            this.updateParams(params);
        },
    
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },
    
        onSortChange(params) {
            this.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
            });
        },
  
        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },
    

        editData(index, row) {

            var params = this.$onRandom(row.id_header);
            window.location.href = "/sales-survey/v2/edit/" + params;

        },


        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'SalesSurveyV2Controller') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;

        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },


        cek_message(status,msg){
            if(status=='200'){
                this.success(msg);
            }
        },

    },
    events: {},
    created: function () { },
    mounted() {

        this.fetchIt();
        this.cek_message(this.$route.query.status,this.$route.query.msg);


    },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>